import { Portal as PortalPrimitive } from "radix-ui";

const Portal = PortalPrimitive.Root;

export { Portal };
